import { jsx as a } from "react/jsx-runtime";
import l from "@mui/material/SvgIcon";
import * as o from "react";
import { forwardRef as c } from "react";
const m = (t) => /* @__PURE__ */ o.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "6 8 20 16", ...t }, /* @__PURE__ */ o.createElement("path", { fill: "currentColor", d: "M23.826 8H8.174c-.286 0-.568.054-.832.16a2.2 2.2 0 0 0-.705.457C6.229 9.01 6 9.547 6 10.105v1.685c0 .075.021.15.06.214a.43.43 0 0 0 .167.155l9.565 5.053a.45.45 0 0 0 .416 0l9.566-5.053a.43.43 0 0 0 .165-.155.4.4 0 0 0 .061-.214v-1.685c0-.558-.229-1.094-.637-1.488A2.2 2.2 0 0 0 23.826 8" }), /* @__PURE__ */ o.createElement("path", { fill: "currentColor", d: "M16.625 17.951a1.34 1.34 0 0 1-1.248 0L6.01 13.004l-.01.007v8.884c0 .558.229 1.094.637 1.488.407.395.96.617 1.537.617h15.652a2.2 2.2 0 0 0 1.537-.617c.408-.394.637-.93.637-1.488V13.01l-.01-.006z" })), f = /* @__PURE__ */ c(({ size: t = "inherit", sx: e, ...r }, n) => {
  const i = typeof e == "function" ? e : {
    fontSize: t,
    ...e
  };
  return /* @__PURE__ */ a(l, {
    ...r,
    ref: n,
    component: m,
    inheritViewBox: !0,
    sx: i
  });
});
f.displayName = "svg_mail";
export {
  f as default
};
